import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

interface DialogCreditBlockProps {
  onConfirm: () => void;
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  okText?: string | React.ReactNode;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "73px 24px 20px 24px",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        padding: "0px 24px 0 24px",
        height: 48,
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 32px",
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    }
  }),
  { name: "DialogCreditBlock" }
);

const DialogCreditBlock: React.FC<DialogCreditBlockProps> = ({
  onConfirm,
  open,
  title,
  content,
  okText
}) => {
  const classes = useStyles({});
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      className={classes.root}
      data-testid="dialogCreditBlock"
    >
      {title ? (
        <DialogTitle>
          <MyTypography variant="h6">{title}</MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      {content ? <DialogContent>{content}</DialogContent> : ""}
      <DialogActions disableSpacing={true}>
        {okText && (
          <Button
            id="closeButton"
            data-testid="closeButton"
            color="primary"
            variant="contained"
            className={classes.btnAction}
            fullWidth={true}
            onClick={onConfirm}
          >
            <MyTypography variant="body1">{okText}</MyTypography>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogCreditBlock;
